import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromUser from './user.reducers';

export const reducers = fromUser.reducer;

export const selectUserState = createFeatureSelector<any>('auth');

export const getUser = createSelector(selectUserState, fromUser.getUser);

export const getUserEmail = createSelector(selectUserState, fromUser.getUserEmail);

export const getHasWallet = createSelector(selectUserState, fromUser.getHasWallet);

export const getError = createSelector(selectUserState, fromUser.getError);

export const getLikedItems = createSelector(selectUserState, fromUser.getLikedItems);

export const getWelcomeVoucher = createSelector(selectUserState, fromUser.getWelcomeVoucher);

export const getPriceDropFollowItems = createSelector(selectUserState, fromUser.getPriceDropFollowItems);

export const getWishedItems = createSelector(selectUserState, fromUser.getWishedItems);

export const getFollowingMembers = createSelector(selectUserState, fromUser.getFollowingMembers);

export const isPending = createSelector(selectUserState, fromUser.isLoading);

export const isAuthenticated = createSelector(selectUserState, fromUser.isAuthenticated);

export const getWallet = createSelector(selectUserState, fromUser.getWallet);
